module.exports = __webpack_public_path__ + "img/new-blue.1b176dc4.svg";